export default __webpack_public_path__ + "static/media/linkedin-icon.9a8602cf.svg";